import { CampaignId } from '@shared/types/campaign.ts';

export const apiRoutes = {
  readCampaign: (campaignId: CampaignId) => `/campaigns/${campaignId}`,
  submitCampaign: (campaignId: CampaignId) => `/campaigns/${campaignId}/submit`,
  getCampaigns: () => '/campaigns',
  deleteCampaign: (campaignId: CampaignId) => `/campaigns/${campaignId}`,
};
